/**
 * Stores (Storage & Database) API client — wraps the `/datasets/*` routes
 * served by the backend, base-path mapped onto api-${stage}.zibby.app.
 *
 *   list() → { ok, stores: [{ storeId, name, type, description, schema,
 *                              status, createdAt }] }
 *
 * The `/datasets` registry is PROJECT-TOKEN scoped (it's the same API the
 * cloud agent + Copilot call) — it rejects the user session token. So the
 * caller passes the current project's `apiToken` (already delivered to the
 * browser via GET /projects) and we send it as the per-call Authorization
 * override. The token also pins the tenant server-side, so there's no
 * projectId argument.
 *
 * Stores are CREATED conversationally (via the agent / Copilot), so there
 * is no create/update/delete client here — this surface is read-only.
 */

import api from './api';

const BASE = '/datasets';

export const Stores = {
  /**
   * List the project's stores (databases / data stores).
   * @param {string} projectToken - the project's apiToken (the /datasets
   *   registry authenticates with the project token, not the session token).
   * @returns {Promise<{ ok: boolean, stores: Array }>}
   */
  list(projectToken) {
    return api.get(`${BASE}/stores`, { authToken: projectToken });
  },
};

export default Stores;
